import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon/Icon';

export interface Props {
  id?: string;
  withLogo?: boolean;
}

const BackgroundWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  background-color: #202020;
`;

const LogoWrapper = styled.div`
  position: absolute;
  top: 40px;
  left: 40px;
`;

const ArrowWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`;

const Background: React.FC<React.PropsWithChildren<Props>> = ({ id, withLogo = true }) => {
  return (
    <BackgroundWrapper id={id}>
      {withLogo && (
        <LogoWrapper>
          <Icon name="TKHSecurityLogo" width={170} height={64} />
        </LogoWrapper>
      )}
      <ArrowWrapper>
        <Icon name="ArrowBackground" width={407} height={672} />
      </ArrowWrapper>
    </BackgroundWrapper>
  );
};

export default Background;
